"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

var _JSUtils = require("../../JSUtils");

var _plotly = _interopRequireDefault(require("plotly.js"));

var _factory = _interopRequireDefault(require("./factory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Plot = (0, _factory["default"])(_plotly["default"]);

function _default(props) {
  var data = props.data,
      _props$width = props.width,
      width = _props$width === void 0 ? 250 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 200 : _props$height,
      _props$title = props.title,
      title = _props$title === void 0 ? "Plot" : _props$title,
      dark = props.dark,
      _props$xaxis = props.xaxis,
      xaxis = _props$xaxis === void 0 ? {} : _props$xaxis,
      _props$yaxis = props.yaxis,
      yaxis = _props$yaxis === void 0 ? {} : _props$yaxis,
      displayModeBar = props.displayModeBar,
      onClickCallback = props.onClickCallback;
  var axes = {
    visible: true,
    color: dark && '#fff'
  };
  var sColor = {
    color: dark && '#fff'
  };
  if (!data || !(0, _JSUtils.isArray)(data) || data.length === 0) return null;
  return _react["default"].createElement(Plot, {
    data: data,
    layout: {
      width: width,
      height: height,
      title: {
        text: title,
        font: sColor
      },
      margin: {
        t: 30,
        r: 20,
        b: 50,
        l: 30
      },
      paper_bgcolor: dark && '#0000',
      plot_bgcolor: dark && '#0000',
      xaxis: Object.assign(axes, xaxis),
      yaxis: Object.assign(sColor, yaxis),
      legend: {
        x: 0.35,
        y: -0.35,
        orientation: 'h',
        font: sColor
      }
    },
    onClick: function onClick(e) {
      typeof onClickCallback === 'function' && onClickCallback(e.points);
    },
    config: {
      displayModeBar: !displayModeBar && false
    }
  });
}